import {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {getOrders, cancelOrder} from '../api/orderApi';
import { isLoggedIn } from '../utils/tokenUtils';
import styles from './OrderListPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function OrderListPage()
{
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if(!isLoggedIn()) {
            alert('로그인이 필요합니다.');
            navigate('/login');
            return;
        }
        const loadOrders = async () => {
            try {
                const response = await getOrders();
                setOrders(response.data);
            }
            catch (err) {
                console.error('주문 내역 로딩 실패', err);
            }
            finally {
                setLoading(false);
            }
        };
        loadOrders();
    }, []);

    const handleCancel = async (e, orderId) => {
        e.stopPropagation();
        if (!window.confirm('주문을 취소하시겠습니까?')) return;
        try {
            await cancelOrder(orderId);
            setOrders(prev => prev.map(o =>
                o.orderId === orderId ? { ...o, status: 'CANCELLED' } : o
            ));
            alert('주문이 취소되었습니다.');
        } catch (err) {
            alert('주문 취소에 실패했습니다.');
        }
    };

    const statusLabel = {
        PENDING: '결제 대기',
        PAID: '결제 완료',
        SHIPPING: '배송 중',
        DELIVERED: '배송 완료',
        CANCELLED: '주문 취소'
    };

    if (loading)
    {
        return <p className={styles.loading}>로딩 중...</p>;
    }

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>주문 내역</h2>

            {orders.length === 0 ? (
                <div className={styles.empty}>
                    <p>주문 내역이 없습니다.</p>
                    <button onClick={() => navigate('/products')} className={styles.shopButton}>
                        쇼핑하러 가기
                    </button>
                </div>
            ) : (
                <div className={styles.orderList}>
                    {orders.map(order => (
                        <div
                            key={order.orderId}
                            className={styles.orderCard}
                            onClick={() => navigate(`/orders/${order.orderId}`)}
                        >
                            <div className={styles.orderHeader}>
                                <span className={styles.orderId}>주문번호 {order.orderId}</span>
                                <span className={styles[order.status.toLowerCase()]}>
                                    {statusLabel[order.status]}
                                </span>
                            </div>
                            <div className={styles.orderItems}>
                                {order.orderItems.slice(0, 2).map(item => (
                                    <div key={item.orderItemId} className={styles.itemRow}>
                                        <img
                                            src={`${API_URL}${item.imageUrl}`}
                                            alt={item.productName}
                                            className={styles.itemImage}
                                        />
                                        <span className={styles.itemName}>{item.productName}</span>
                                        <span className={styles.itemQuantity}>{item.quantity}개</span>
                                    </div>
                                ))}
                                {order.orderItems.length > 2 && (
                                    <p className={styles.moreItems}>외 {order.orderItems.length - 2}개</p>
                                )}
                            </div>
                            <div className={styles.orderFooter}>
                                <span className={styles.date}>
                                    {new Date(order.createdAt).toLocaleDateString()}
                                </span>
                                <span className={styles.totalPrice}>
                                    {order.totalPrice.toLocaleString()}원
                                </span>
                                {(order.status === 'PENDING' || order.status === 'PAID') && (
                                    <button
                                        className={styles.cancelBtn}
                                        onClick={(e) => handleCancel(e, order.orderId)}
                                    >
                                        주문 취소
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default OrderListPage;